import * as THREE from 'three';

// Info(Katia): get the size of a certain element
export const getBoxSize = (item: THREE.Group): THREE.Vector3 => {
	const box = new THREE.Box3().setFromObject(item);
	return box.getSize(new THREE.Vector3());
};
